
<template>
  <div>
    <!-- 登录弹窗 -->
    <a-modal title=""
             :visible="login.visible"
             @cancel="()=>{login.visible = false, clearTimer()}"
             :centered="true"
             :footer="null">
      <a-tabs default-active-key="1"
              @change="clearTimer()">
        <a-tab-pane key="1"
                    tab="密码登录">
          <a-form-model layout="horizontal"
                        :model="formInline"
                        :rules="rules"
                        ref="loginForm"
                        @submit="accountPsdSubmit"
                        @submit.native.prevent>
            <a-form-model-item prop="user">
              <a-input v-model="formInline.user"
                       placeholder="请输入手机号"
                       :maxLength="11">
                <a-icon slot="prefix"
                        type="user"
                        style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password"
                               key="password">
              <a-input v-model="formInline.password"
                       type="password"
                       :maxLength="20"
                       placeholder="请输入密码">
                <a-icon slot="prefix"
                        type="lock"
                        style="color:rgba(0,0,0,.25)" />
              </a-input>

            </a-form-model-item>
            <div class="password-hint color-transparent">默认密码为注册手机号后6位</div>
            <a-form-model-item>
              <a-button class="submit"
                        html-type="submit">
                登录
              </a-button>
            </a-form-model-item>
          </a-form-model>
          <div class="login-type">

            <span v-if="loginType == 1"
                  @click="forgetPsdShow"
                  class="cursor-pointer">忘记密码?</span>
            <a-divider v-if="loginType == 1"
                       type="vertical" />
            <span @click="register"
                  class="cursor-pointer">新用户注册</span>

          </div>
        </a-tab-pane>
        <a-tab-pane key="2"
                    tab="手机验证码登录"
                    force-render>

          <a-form-model layout="horizontal"
                        :model="formInline"
                        :rules="rules"
                        ref="loginCodeForm"
                        @submit="handleCodeSubmit"
                        @submit.native.prevent>
            <a-form-model-item prop="user">
              <a-input v-model="formInline.user"
                       placeholder="请输入手机号"
                       :maxLength="11">
                <a-icon slot="prefix"
                        type="user"
                        style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item class="code-view"
                               prop="code"
                               key="code">
              <a-input v-model="formInline.code"
                       :maxLength="6"
                       placeholder="请输入验证码">
                <a-icon slot="prefix"
                        type="message"
                        style="color:rgba(0,0,0,.25)" />
              </a-input>
              <div :class="['code', count == 0? '' : 'got-code']"
                   @click="getCode(1)">{{codeHint}}</div>
            </a-form-model-item>
            <div class="password-hint color-transparent">默认密码为注册手机号后6位</div>
            <a-form-model-item>
              <a-button class="submit"
                        html-type="submit">
                登录
              </a-button>
            </a-form-model-item>
          </a-form-model>
          <div class="login-type">
            <span @click="register"
                  class="cursor-pointer">新用户注册</span>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-modal>

    <!-- 重置密码弹窗 -->
    <a-modal title="重置密码"
             :visible="resetPassword.visible"
             @cancel="closeResetPasswordModel"
             :footer="null">
      <a-form-model layout="horizontal"
                    :model="resetPassword.form"
                    :rules="rules"
                    ref="resetPsdForm">
        <a-form-model-item prop="user">
          <a-input v-model="resetPassword.form.user"
                   placeholder="请输入手机号"
                   :maxLength="11">
            <a-icon slot="prefix"
                    type="user"
                    style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item class="code-view"
                           prop="code">
          <a-input v-model="resetPassword.form.code"
                   :maxLength="6"
                   placeholder="请输入验证码">
            <a-icon slot="prefix"
                    type="message"
                    style="color:rgba(0,0,0,.25)" />
          </a-input>
          <div :class="['code', resetPassword.count == 0? '' : 'got-code']"
               @click="getCode(2)">{{resetPassword.codeHint}}</div>
        </a-form-model-item>
        <a-form-model-item prop="password">
          <a-input v-model="resetPassword.form.password"
                   type="password"
                   :readonly='resetPassword.readonly'
                   :maxLength="20"
                   @focus="()=>{resetPassword.readonly = false}"
                   placeholder="请输入新密码">
            <a-icon slot="prefix"
                    type="lock"
                    style="color:rgba(0,0,0,.25)" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="submit"
                    @click="resetPsdForm">
            确定
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 注册成功 -->
    <a-modal title="恭喜您已注册成功"
             class="register-success"
             :visible="registerSuccess.visible"
             @cancel="()=>{registerSuccess.visible = false}"
             :footer="null">

      <a-form-model layout="horizontal"
                    ref="registerSuccess">
        <a-form-model-item label="姓名">
          <span class="value">{{registerSuccess.massage.name}}</span>
        </a-form-model-item>
        <a-form-model-item label="手机号/登录账号">
          <span class="value">{{registerSuccess.massage.phone}}</span>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="submit"
                    @click="()=>{registerSuccess.visible = false}">
            确定
          </a-button>
        </a-form-model-item>

      </a-form-model>

    </a-modal>
    <!-- 新用户注册 -->
    <a-modal title="新用户注册"
             class="new-user-registration"
             :visible="newUserRegistration.visible"
             @cancel="closeNewUserRegistrationModel"
             :footer="null">

      <a-form-model layout="horizontal"
                    :model="newUserRegistration.form"
                    :rules="rules"
                    ref="newUserRegistrationForm">
        <a-form-model-item prop="name"
                           label="姓名">
          <a-input v-model="newUserRegistration.form.name"
                   placeholder="请输入姓名"
                   :maxLength="50">
          </a-input>
        </a-form-model-item>

        <a-form-model-item prop="sex"
                           label="性别">
          <a-radio-group :options="sexOptions"
                         :default-value="newUserRegistration.form.sex"
                         @change="sexOnChange" />
        </a-form-model-item>

        <a-form-model-item prop="user"
                           label="手机号"
                           class="phone">
          <a-input addon-before="+86 >"
                   v-model="newUserRegistration.form.user"
                   placeholder="请输入手机号"
                   @change="phoneChange"
                   :maxLength="11">
          </a-input>
          <span class="hint">手机号码将作为登录账号使用</span>
        </a-form-model-item>

        <a-form-model-item class="code-view"
                           prop="code"
                           label="手机验证码">
          <a-input v-model="newUserRegistration.form.code"
                   :maxLength="6"
                   placeholder="请输入验证码">
          </a-input>
          <div :class="[newUserRegistration.count == 0? 'code' : 'got-code']"
               @click="getCode(3)">{{newUserRegistration.codeHint}}</div>
        </a-form-model-item>

        <a-form-model-item prop="password"
                           label="密码">
          <a-input v-model="newUserRegistration.form.password"
                   type="password"
                   :readonly='newUserRegistration.readonly'
                   :maxLength="20"
                   @focus="()=>{newUserRegistration.readonly = false}"
                   placeholder="请输入密码">
          </a-input>

          <span class="hint">默认密码为手机号后6位</span>
        </a-form-model-item>
        <a-form-model-item>
          <a-button class="submit"
                    @click="registrForm">
            确定
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { login, getVerificationCode, phoneCodeLogin, resetPassword, registerUserInfo } from "../../assets/api/api";
export default {
  name: 'UserIndex',
  data () {
    return {
      loginType: 1,
      login: {
        visible: false
      },
      formInline: {
        user: '',
        password: '',
        code: ''
      },
      rules: {
        user: [
          { required: true, message: '请输入手机号', trigger: ['change', 'blur'] },
          {
            validator: (rule, value, cbfn) => {
              const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
              if (!reg.test(value)) {
                cbfn('请输入正确的手机号码')
              }
              cbfn()
            }
          }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: ['change', 'blur'] },
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: ['change', 'blur'] },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: ['change', 'blur'] },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: ['change', 'blur'] },
          {
            validator: (rule, value, cbfn) => {
              const reg = /^[0-9]{6}$/
              if (!reg.test(value)) {
                cbfn('请输入正确的验证码')
              }
              cbfn()
            }
          }
        ]
      },
      codeHint: '获取验证码',
      count: 0,
      countInterval: null,
      resetPassword: { // 重置密码
        visible: false,
        readonly: true,
        codeHint: '获取验证码',
        count: 0,
        countInterval: null,
        form: {
          user: '',
          password: '',
          code: ''
        }
      },
      codeType: 1,

      // 注册成功
      registerSuccess: {
        visible: false,
        massage: {
          name: '',
          phone: ''
        }
      },
      // 新用户注册
      newUserRegistration: {
        visible: false,
        readonly: true,
        codeHint: '获取验证码',
        count: 0,
        countInterval: null,
        form: {
          name: '',
          sex: 1,
          user: '',
          code: '',
          password: ''
        }
      },
      sexOptions: [
        { label: '男', value: 1 },
        { label: '女', value: 2 }
      ]
    }
  },
  methods: {
    // 显示重置密码弹窗
    forgetPsdShow () {
      this.resetPassword.visible = true
      this.resetPassword.form = {
        user: '',
        password: '',
        code: ''
      }
    },
    /**
     * 账号密码登录
     */
    accountPsdSubmit () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          const params = {
            phone: this.formInline.user,
            password: this.formInline.password
          }
          login(params).then(res => {
            if (res.code == 1) {
              this.loginSuccess(res)
            } else {
              this.$message.error(res.msg);
            }

          }).catch((err) => {
          }).finally(() => {
          })
        }
      })
    },
    /**
     * 账号验证码登录
     */
    handleCodeSubmit () {
      this.$refs.loginCodeForm.validate(valid => {
        if (valid) {
          const params = {
            phone: this.formInline.user,
            code: this.formInline.code
          }
          phoneCodeLogin(params).then(res => {
            if (res.code == 1) {
              this.loginSuccess(res)
            } else {
              this.$message.error(res.msg);
            }

          }).catch((err) => {
            //  console.log(err)
          }).finally(() => {
          })
        }
      })
    },
    /**
     * 登陆成功保存信息
     */
    loginSuccess (res) {
      this.isLogin = true
      this.login.visible = false
      localStorage.setItem('phone', res.data.phone)
      localStorage.setItem('headImgUrl', res.data.headImgUrl)
      localStorage.setItem('realName', res.data.realName ? res.data.realName : '')
      localStorage.setItem('userId', res.data.autoId)
      this.$message.success('恭喜您，登录成功！');
      this.$emit('checkLogin', '')
      this.formInline = {
        user: '',
        password: '',
        code: ''
      }
    },
    register () {
      this.newUserRegistration.visible = true
    },
    registrForm () {
      this.$refs.newUserRegistrationForm.validate(valid => {
        if (valid) {
          const params = {
            phone: this.newUserRegistration.form.user,
            code: this.newUserRegistration.form.code,
            userSex: this.newUserRegistration.form.sex == 1 ? '男' : ' 女',
            realName: this.newUserRegistration.form.name,
            newPassword: this.newUserRegistration.form.password
          }
          registerUserInfo(params).then(res => {
            if (res.code == 1) {
              this.registerSuccess.massage.name = this.newUserRegistration.form.name
              this.registerSuccess.massage.phone = this.newUserRegistration.form.user
              this.closeNewUserRegistrationModel()
              this.registerSuccess.visible = true
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            //  console.log(err)
          }).finally(() => {
          })
        }
      })
    },
    closeNewUserRegistrationModel () {
      this.codeType == 3
      this.clearTimer()
      this.$refs.newUserRegistrationForm.resetFields()
      this.newUserRegistration.visible = false
    },
    /**
     * 重置密码
     */
    resetPsdForm () {
      this.$refs.resetPsdForm.validate(valid => {
        if (valid) {
          const params = {
            phone: this.resetPassword.form.user,
            code: this.resetPassword.form.code,
            newPassword: this.resetPassword.form.password
          }
          resetPassword(params).then(res => {
            if (res.code == 1) {
              this.$message.success('重置密码成功');
              this.resetPassword.visible = false
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
          }).finally(() => {
          })
        }
      })
      console.log(this.resetPassword)
    },
    /**
     * 获取验证码
     */
    getCode (code) {
      this.codeType = code
      let params = {}
      if (code == 2) {
        if (this.resetPassword.countInterval) return;
        if (!this.resetPassword.form.user) {
          this.$message.error('手机号码不能为空');
          return;
        }
        params = {
          phone: this.resetPassword.form.user
        }
      } else if (code == 1) {
        if (this.countInterval) return;
        if (!this.formInline.user) {
          this.$message.error('手机号码不能为空');
          return;
        }
        params = {
          phone: this.formInline.user
        }
      } else if (code == 3) {
        if (this.newUserRegistration.countInterval) return;
        if (!this.newUserRegistration.form.user) {
          this.$message.error('手机号码不能为空');
          return;
        }
        params = {
          phone: this.newUserRegistration.form.user,
          register: 1
        }
      }

      getVerificationCode(params).then(res => {
        if (res.flag == 1) {
          this.$message.success("发送成功");
          if (this.codeType == 1) {
            this.count = 59
            this.codeHint = this.count + 's后重新获取'
            this.countInterval = setInterval(() => {
              this.count--;
              if (this.count == 0) {
                this.codeHint = '获取验证码'
                this.clearTimer()
              } else {
                this.codeHint = this.count + 's后重新获取'
              }
            }, 1000);
          } else if (this.codeType == 2) {
            this.resetPassword.count = 59
            this.resetPassword.codeHint = this.resetPassword.count + 's后重新获取'
            this.newUserRegistration.countInterval = setInterval(() => {
              this.resetPassword.count--;
              if (this.resetPassword.count == 0) {
                this.resetPassword.codeHint = '获取验证码'
                this.clearTimer()
              } else {
                this.resetPassword.codeHint = this.resetPassword.count + 's后重新获取'
              }
            }, 1000);
          } else if (this.codeType == 3) {
            this.newUserRegistration.count = 59
            this.newUserRegistration.codeHint = this.newUserRegistration.count + 's后重新获取'
            this.newUserRegistration.countInterval = setInterval(() => {
              this.newUserRegistration.count--;
              if (this.newUserRegistration.count == 0) {
                this.newUserRegistration.codeHint = '获取验证码'
                this.clearTimer()
              } else {
                this.newUserRegistration.codeHint = this.newUserRegistration.count + 's后重新获取'
              }
            }, 1000);
          }
        } else {
          this.$message.error(res.msg);
        }

      }).catch((err) => {
        //  console.log(err)
      }).finally(() => {
      })
    },
    /**
     * 清除定时器
     */
    clearTimer () {
      if (this.codeType == 1) {
        if (this.countInterval) {
          clearInterval(this.countInterval)
          this.countInterval = null
        }
        this.codeHint = '获取验证码'
        this.count = 0
      } else if (this.codeType == 2) {
        if (this.resetPassword.countInterval) {
          clearInterval(this.resetPassword.countInterval)
          this.resetPassword.countInterval = null
        }
        this.resetPassword.codeHint = '获取验证码'
        this.resetPassword.count = 0
      } else if (this.codeType == 3) {
        if (this.newUserRegistration.countInterval) {
          clearInterval(this.newUserRegistration.countInterval)
          this.newUserRegistration.countInterval = null
        }
        this.newUserRegistration.codeHint = '获取验证码'
        this.newUserRegistration.count = 0
      }
    },
    sexOnChange (value) {
      this.newUserRegistration.form.sex = value.target.value
    },
    closeResetPasswordModel () {
      this.resetPassword.visible = false
      this.codeType == 2
      this.clearTimer()
      this.$refs.resetPsdForm.resetFields()
    },
    phoneChange(e) {
      if(this.newUserRegistration.form.user.length == 11) {
        this.newUserRegistration.form.password = this.newUserRegistration.form.user.slice(5,11)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ant-tabs-nav-scroll {
  display: flex;
  justify-content: center;
}

/deep/ .ant-tabs-bar {
  border-bottom: 0px;
}

/deep/ .ant-tabs-nav .ant-tabs-tab,
/deep/ .ant-tabs-nav .ant-tabs-tab:hover {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.65);
  padding: 9px 16px;
}

/deep/ .ant-tabs-nav .ant-tabs-tab-active,
/deep/ .ant-tabs-nav .ant-tabs-tab-active:hover {
  color: #262626;
  font-weight: 700;
  text-shadow: 0 0 0 transparent !important;
  font-style: normal;
  font-size: 18px;
}

/deep/.ant-form {
  margin: 0 40px;
}

/deep/ .ant-input {
  border-radius: 20px;
  background-color: #ffffff;
}

/deep/.ant-form-item {
  margin-bottom: 15px;
}

.submit {
  width: 100%;
  background-color: #2d78c5;
  color: #ffffff;
  line-height: 30px;
}

.password-hint {
  font-size: 14px;
  color: #999999;
  margin-bottom: 15px;
  margin-top: -15px;
}

.color-transparent {
  color: transparent;
}

.code-view /deep/ .ant-form-item-children {
  display: flex;
  align-items: center;
}
.code-view {
  .code {
    width: 140px;
    line-height: 30px;
    text-align: end;
    color: #2d78c5;
  }

  .got-code {
    color: #999999;
  }
}

.login-type {
  font-size: 14px;
  color: #666666;
  text-align: center;
  margin: 0;
  line-height: 1.1;
  font-weight: 400;
}

/deep/ .ant-modal-wrap::before {
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
  content: "";
}

/deep/ .ant-modal-wrap {
  display: flex;
  align-items: center;
}

/deep/ .ant-modal {
  top: 0;
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}

/deep/ .ant-modal-title {
  text-align: center;
}

// 注册样式
.new-user-registration /deep/ .ant-form-item {
  display: flex;
  width: 100%;
  border-bottom: 1px solid #f5f5f5;
}

.new-user-registration /deep/ .ant-form-item:last-child {
  border-bottom: 0px;
}

.new-user-registration /deep/ .ant-form-item-label {
  width: 100px;
  text-align: left;
}

.new-user-registration /deep/ .ant-form-item-control-wrapper {
  width: 100%;
}

.new-user-registration /deep/ .ant-input,
.new-user-registration /deep/ .ant-input:focus {
  border: 0;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-modify: read-write-plaintext-only;
  border-radius: 0px;
  border-width: 0px;
  border: none;
  box-shadow: none;
}

.new-user-registration .code {
  background-color: #2d78c5;
  color: #ffffff;
  height: 30px;
  border-radius: 5px;
  text-align: center;
  width: 180px;
  line-height: 30px;
}

.new-user-registration .got-code {
  background-color: #ffffff;
  color: #999999;
  height: 30px;
  border-radius: 5px;
  text-align: center;
  width: 180px;
  line-height: 30px;
  border: 1px solid #999999;
}

.new-user-registration .code-view /deep/ .ant-form-item-label {
  line-height: 33px;
}

.new-user-registration /deep/ .ant-input-group-addon {
  padding: 0px;
  background-color: transparent;
  border: 0;
}

.new-user-registration .phone /deep/ .ant-input-group-addon {
  border-right: 1px solid #dadada;
  width: auto;
  padding-right: 10px;
  line-height: 1;
}

.new-user-registration .phone /deep/ .ant-input {
  width: 90%;
}

.new-user-registration .phone /deep/ .ant-input-group {
  display: flex;
  align-items: center;
}

.new-user-registration /deep/ .has-error .ant-input,
.new-user-registration /deep/ .has-error .ant-input:hover {
  border: 0;
  border-color: transparent;
  box-shadow: none;
}

.hint {
  color: #fd3f31;
}

.register-success /deep/ .ant-form-item {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.register-success /deep/ .value {
  color: #262626;
}

.register-success /deep/ .ant-form-item-label > label {
  color: #999999;
}

.register-success .submit /deep/ .ant-form-item-control-wrapper {
  width: 100%;
}
</style>
